import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'record',
  tabs: 'record',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'metadata-subtitle',
        type: 'metadata',
      },
      {
        id: 'tab-bar',
        type: 'tabs',
        options: {
          tabsContents: [
            'metadata-bib-title', 'metadata-bib-parte', 'metadata-bib-notas',
            'metadata-bib-manuscrito', 'metadata-bib-otra', 'metadata-bib-colecciones',
            'metadata-bib-ediciones', 'metadata-bib-refundiciones', 'metadata-bib-biblio',
            'metadata-fec-fecha', 'metadata-fec-computo',
            'metadata-per-computables', 'metadata-per-no-computables', 'metadata-per-universo',
            'metadata-per-ambientacion', 'metadata-per-espaciosI', 'metadata-per-espaciosII',
            'metadata-per-espaciosIII', 'metadata-per-duracion',
            'metadata-gen-adscripcion', 'metadata-gen-adscripcion-secundaria',
            'metadata-gen-notas', 'metadata-gen-sinopsis', 'metadata-gen-autor',
          ]
        }
      }
    ],
    content: [
      {
        id: 'button',
        type: 'button',
        options: {
          text: 'Descargar PDF',
          link: 'pdf-download',
          iconRight: 'n7-icon-download'
        }
      },
      {
        id: 'metadata-bib-title',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-parte',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-notas',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-manuscrito',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-otra',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-colecciones',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-ediciones',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-refundiciones',
        type: 'metadata',
        title: '',
      },
      {
        id: 'metadata-bib-biblio',
        type: 'metadata',
        title: '',
      },
      // {
      //   id: 'text-viewer',
      //   type: 'text-viewer',
      //   options: {
      //     searchId: 'xml_text',
      //   },
      // },
      // {
      //   id: 'collection-witnesses',
      //   type: 'collection',
      //   grid: 3,
      //   title: 'Testimoni collegati',
      // },
      // {
      //   id: 'collection-taxonomies',
      //   type: 'collection',
      //   grid: 3,
      //   title: 'Tassonomie collegate',
      // },
    ],
  },
} as ConfigMurucaResourceLayout;
